import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApacheflinkComponent } from './simple-icons-apacheflink.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApacheflinkComponent ],
    exports:      [ SimpleIconsApacheflinkComponent ],
    bootstrap:    []
})
export class SimpleIconsApacheflinkModule {}
